module.exports = __webpack_public_path__ + "static/nest-98410c1774fee37cf42d3e0c107aaf55.svg";